import styled, { css } from 'styled-components';
import { getMargins } from '@oneaudi/unified-web-common';
import {} from './index.js';
import { getResponsiveStyles } from './get-responsive-styles.js';
export const getPaddings = (paddings) => paddings && paddings.join(' ');
export const StyledLayout = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  padding: ${(props) => getPaddings(props.padding)};
  display: flex;
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
  row-gap: ${(props) => props.rowGap};
  column-gap: ${(props) => props.columnGap};
  ${(props) => getResponsiveStyles({
    'align-items': props.flexAlign,
    'flex-wrap': props.flexWrap,
    'flex-direction': props.flexDirection,
    'justify-content': props.flexJustify
})}

  ${(props) => props.flexDirection === 'row' &&
    css `
      svg {
        flex-shrink: 0;
      }
    `}
`;
//# sourceMappingURL=index.styles.js.map